import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            Категории товаров
          </h2>
          <p className="text-foreground-600 text-sm max-w-lg mx-auto">
            Выберите категорию, чтобы перейти к таблице с товарами
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.key}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col overflow-hidden rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              </div>
              <div className="flex items-center gap-2 px-3 py-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                  <i className={`${cat.icon} text-sm`}></i>
                </div>
                <span className="text-xs md:text-sm font-medium text-foreground-800 leading-tight whitespace-nowrap">
                  {cat.name}
                </span>
                <div className="ml-auto flex-shrink-0 w-5 h-5 flex items-center justify-center rounded-full bg-background-100 opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-arrow-right-up-line text-foreground-500 text-xs"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}